import { useLocation } from "react-router-dom";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { getPathLocale, localeForLanguage, localizeHref } from "./localizedRoutes";

export const useSiteLocale = () => {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  return getPathLocale(pathname) || localeForLanguage(i18n.resolvedLanguage || i18n.language);
};

export const useLocalizedPath = () => {
  const locale = useSiteLocale();
  return useCallback((href: string) => localizeHref(href, locale), [locale]);
};
